import { useNavigate, useRouterState } from "@tanstack/react-router";
import { getLenis } from "./lenis";

/**
 * Every "Get a Quote" / "Request a Quote" button on the site uses this.
 * - Already on /contact: smooth-scroll to the #quote form (Lenis if available,
 *   native fallback otherwise), offset for the fixed header.
 * - Anywhere else: navigate to /contact#quote (the contact page scrolls to the
 *   form on mount via its hash effect).
 */
export function useGoToQuote() {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return () => {
    if (typeof window === "undefined") return;
    if (pathname === "/contact") {
      const lenis = getLenis();
      if (lenis) {
        lenis.scrollTo("#quote", { offset: -100 });
      } else {
        document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" });
      }
      return;
    }
    void navigate({ to: "/contact", hash: "quote" });
  };
}
